class navigate {
  static to;
  static navigated = false;

  static init(navFunc) {
    navigate.to = function () {
      navigate.navigated = true;
      navFunc.apply(navFunc, arguments)
    };
  }
}

export default navigate;
